<template>
  <v-container fluid class="claim-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Claim</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3">File</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Claim</p>
                        <v-select
                          class="mb-4"
                          :items=claimtype
                          v-model="claim.claimtype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the claim type">
                        </v-select>
                        <v-menu
                          ref="menu_claimdate"
                          v-model="menu_claimdate"
                          :close-on-content-click="false"
                          :return-value.sync="claim.claimdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="claim.claimdate"
                              label="Claim Date"
                              v-bind="attrs"
                              v-bind:value="claim.claimdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line
                              persistent-hint 
                              hint="Please choose the claim date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="claim.claimdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_claimdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_claimdate.save(claim.claimdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-switch
                          readonly
                          v-model="claim.claimstatus"
                          color="primary"
                          v-bind:label="claim.claimstatus"
                          value="New"
                        ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="employees.filter(employee=>employee.employeestatus=='Active').map(x => {
                            return {text: x.employeename, value: x._id};
                            })"
                          v-model="claim.employeeid"
                          v-bind:error="errorindex == 2"
                          v-on:change="populateEmployeeFields"
                          outlined
                          dense
                          persistent-hint
                          readonly
                          placeholder="Employee"
                          single-line hint="Please choose the employee">
                        </v-select>                        
                        <v-text-field
                          class="mb-4"
                          v-model="claim.claimname"
                          outlined
                          dense
                          placeholder="Employee Name"
                          persistent-hint
                          readonly
                          single-line hint="Enter the Employee Name">
                        </v-text-field>
                        <v-textarea
                          v-model="claim.claimaddress"
                          outlined
                          rows=2
                          label="Address"
                          readonly
                          hint="please enter the employee address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="claim.claimphone"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="claim.claimmobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="claim.claimnote"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/my/claim/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-select
                            class="mb-4"
                            :items="claim.claimtype=='Medical Claim' ? accounts.filter(x=>x.accountsubtype=='Medical Claim').map(x => {return {text: x.accountname, value: x._id};}) : accounts.filter(x=>x.accountsubtype=='Expense Claim').map(x => {return {text: x.accountname, value: x._id};})"
                            v-model="accountid"
                            v-bind:error="errorindex == 11"
                            outlined
                            dense
                            placeholder="Account"
                            persistent-hint
                            single-line hint="Account">
                          </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-text-field
                            v-model="transdesc"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Desc"
                            persistent-hint
                            single-line hint="Description">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-text-field
                            v-model="transamount"
                            v-bind:error="errorindex == 12"
                            class="mb-4"
                            type="number"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addTransaction()">
                            Add
                          </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-data-table
                            :headers="itemHeaders"
                            :items="transactions"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                          <template v-slot:item.accountid="{ item }">
                            {{ item.accountid!=null &&accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="deleteTransaction(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                    </v-col>
                  </v-row>
                    <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError3">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload File</p>
                        <p>File:</p>
                        <v-file-input label="File input (pdf, jpg)" v-on:change="onFileChange" accept=".pdf,.jpg" />
                        <v-img contain max-height="150" max-width="250" :src="fileurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 2"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertClaim()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      itemHeaders: [
        { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'transdesc', width: '30%'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      transactions: [],
      accountid: undefined,
      transdesc: undefined,
      transamount: undefined,
      fileurl: undefined,
      filedata: undefined,
      filename: undefined,
      step: 1,
      claim: {
        claimstatus: 'New',
        claimsubtotal: 0,
        claimtotal: 0,
      },
      menu_claimdate: false,
      claimtype: ['Expense Claim','Medical Claim'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('MyAccount', ['isReceiving'])
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    ...mapActions('MyAccount', ['insertClaimRequest']),
    checkError(){
      if(!this.claim.claimtype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.claim.claimdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.claim.employeeid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError2(){
      if(!this.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.transamount){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(this.transactions.length==0){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      this.step = 3;
      return true;
    },
    populateEmployeeFields(employeeid){
      var employee = this.employees.find(employee=>employee._id == employeeid);
      this.claim.employeeid = employee._id;
      this.claim.claimname = employee.employeename;
      this.claim.claimaddress = employee.employeeaddress;
      this.claim.claimphone = employee.employeephone;
      this.claim.claimmobile = employee.employeemobile;
    },
    calculateTotal(){
      let filter = this.transactions.filter(trans=>trans.isTotal!=true);
      this.claim.claimsubtotal = filter.reduce((item, obj) => item + parseFloat(obj.transamount), 0);
      this.claim.claimtotal = this.claim.claimsubtotal;
      if(filter.length>0){
        let index = this.transactions.findIndex(trans=>trans.isTotal==true);
        if(index!=-1) this.transactions.splice(index, 1);
        this.transactions.push({transamount: this.claim.claimtotal, isTotal: true}); 
      }
      else {
        this.transactions = [];
      }
    },
    addTransaction(){
      if(!this.checkError2()){return}
      this.insertTransaction();
      this.calculateTotal();
      this.clearTransaction();
    },
    insertTransaction(){
      this.transactions.push({
        id: Math.floor(Math.random() * Math.pow(10, 10)),
        employeeid: this.claim.employeeid,
        accountid: this.accountid,
        transdesc: this.transdesc,
        transamount: this.transamount,
      });
    },
    onFileChange(file) {
      if (!file) {return;}
      this.filedata = file;
      this.filename = file.name;
    },
    deleteTransaction(item){
      let index = this.findTransactionIndexById(item.id);
      this.transactions.splice(index,1);
      this.calculateTotal();
    },
    clearTransaction(){
      this.accountid = undefined;
      this.transdesc = undefined;   
      this.transamount = undefined;
    },
    findTransactionIndexById(id){
      let index;
      if(this.transactions.find(tran=>tran.id==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].id==id){break;}
      }
      return index;
    },
    async insertClaim() {
      let json = {
        claim: this.claim,
        transactions: this.transactions.filter(trans=>trans.isTotal!=true),
        filedata: this.filedata,
        filename: this.filename,
      }
      await this.insertClaimRequest(json);
      router.push('/my/claim/list');
    },
  },
  async created () {
    let employeeid = localStorage.getItem("employeeid");
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    this.populateEmployeeFields(employeeid);
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
